import React, { createContext, useContext, useMemo } from 'react';

import { LedgerApi } from 'api/ledger';

const InventoryLedgerPreviewContext = createContext(false);

function InventoryLedgerPreviewProvider({ children, v2Preview = false }) {
    return (
        <InventoryLedgerPreviewContext.Provider value={Boolean(v2Preview)}>
            {children}
        </InventoryLedgerPreviewContext.Provider>
    );
}

function useInventoryLedgerPreview() {
    return useContext(InventoryLedgerPreviewContext);
}

function useLedgerApi() {
    const v2Preview = useInventoryLedgerPreview();
    return useMemo(() => new LedgerApi({ version: v2Preview ? 'v2' : 'v1' }), [v2Preview]);
}

export { InventoryLedgerPreviewProvider, useInventoryLedgerPreview, useLedgerApi };
